import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FragmentPipe } from '@shared/pipes/fragment.pipe';
import { SiteMap, SitemapService } from '@shared/shared/services/sitemap.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ten-sitemap-header',
  templateUrl: './sitemap-header.component.html',
  styleUrls: ['./sitemap-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, FragmentPipe],
})
export class SitemapHeaderComponent {
  public siteMap$: Observable<SiteMap> = this.sitemapService.siteMap$;

  constructor(private sitemapService: SitemapService) {}
}
